/**
 * traveller component
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import _get from 'lodash-es/get';

import { faPen, faExclamation, IconDefinition, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

@Component({

    selector: 'traveller',
    templateUrl: 'traveller.html',
    styles: [
        `
        .label{
            font-size: .8rem;
        }
        `
    ]
})
export class TravellerComponent {
    public Yii = Yii;
    @Input() public travellerItem: any;
    @Input() public travellerKey: string;
    @Input() public isError: string[] = [];
    @Input() public showErrors: boolean = false;
    @Input() public editable: boolean = false;

    @Input() public showDetails: boolean = false;
    @Input() public showMessage: boolean = false;
    @Input() public useApis: boolean = true;

    @Output() public removePax: EventEmitter<string> = new EventEmitter();
    @Output() public showPnrEvent: EventEmitter<string> = new EventEmitter();
    @Output() public showTnrEvent: EventEmitter<string> = new EventEmitter();
    @Output() public showTravellerForm: EventEmitter<string> = new EventEmitter();
    //Yii Translation
    public t_nele = Yii.t('wui-shared-js', 'Né le');
    public t_autresprenoms = Yii.t('wui-shared-js', 'Autres prénoms');
    public t_nationalite = Yii.t('wui-shared-js', 'Nationalité');
    public t_passeport = Yii.t('wui-shared-js', 'Passeport N°');
    public t_expirele = Yii.t('wui-shared-js', 'Expire le');
    public t_title = {
        Mr: Yii.t('wui-shared-js', 'M.'),
        Mrs: Yii.t('wui-shared-js', 'Mme'),
        Ms: Yii.t('wui-shared-js', 'Mlle')
    };
    public typeCode = {
        Adult: "ADT",
        Infant: "INF",
        Child: "CHD"
    };

    public message: string;
    public hasApis: boolean = true;

    public dateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));
    public errorLabel: string;
    public isShowingDetails: boolean = false;

    public formActive: boolean = false;

    public iconPen: IconDefinition = faPen;
    public iconExclamation: IconDefinition = faExclamation;
    public iconEye: IconDefinition = faEye;
    public iconEyeSlash: IconDefinition = faEyeSlash;



    public ngOnInit(): void {

        if (this.showErrors) {
            this.message = '';
            this.hasApis = true;
            const nbMissingApis = this.getMissingApis();
            // count nb of errors
            //in case of child or infant
            let missingBirthDate = false;
            if (this.travellerItem.type !== 'Adult') {
                if (!_get(this.travellerItem, 'birthDate')) {

                    missingBirthDate = true;

                    this.message += "<strong>";
                    this.message += Yii.t('wui-shared-js', 'La date de naissance est obligatoire pour un ');
                    switch (this.travellerItem.type) {
                        case "Infant":
                            this.message += Yii.t('wui-shared-js', 'bébé.');
                            break;
                        case "Child":
                            this.message += Yii.t('wui-shared-js', 'enfant.');
                            break;
                    }
                    this.message += "</strong>";
                    this.message += '<br><br>';

                    this.message += Yii.t('wui-shared-js', '<strong>Le PNR ne pourra pas être créé.</strong>');
                }
            }

            if (nbMissingApis !== 0 && nbMissingApis !== 4) {
                if (missingBirthDate) {
                    this.message += '<br><br>';
                }
                // Message if incomplete apis
                this.message += "<strong>";
                this.setMessage();
                this.message += "</strong><br>";
                this.message += '<br>';

                if (!missingBirthDate) {
                    this.message += Yii.t('wui-shared-js', 'Le PNR pourra être créé, mais sans les données suivantes:');
                    this.message += '<br>';
                    this.message += Yii.t('wui-shared-js', 'Passeport, Nationalité.');
                }



            } else if (nbMissingApis === 4) {
                if (missingBirthDate) {
                    this.message += '<br><br>';
                }
                // Message if no Apis
                this.message += "<strong>";
                this.message += Yii.t('wui-shared-js', "Données APIs manquantes");
                this.message += "</strong>";

                if (!missingBirthDate) {
                    this.message += '<br>';
                    this.message += Yii.t('wui-shared-js', 'Le PNR pourra être créé, mais sans les données suivantes:');
                    this.message += '<br>';
                    this.message += Yii.t('wui-shared-js', 'Passeport, Nationalité.');
                }
            } else if (nbMissingApis === 0 && this.travellerItem.type === 'Adult') {
                if (!_get(this.travellerItem, 'birthDate')) {
                    this.message += '<strong>';
                    this.message += Yii.t('wui-shared-js', 'Date de naissance manquante.');
                    this.message += '</strong>';
                    this.message += '<br><br>';
                    this.message += Yii.t('wui-shared-js', 'Le PNR pourra être créé, mais sans les données suivantes:');
                    this.message += '<br>';
                    this.message += Yii.t('wui-shared-js', 'Passeport, Nationalité.');
                }

            }


        }
    }
    public showForm(_key: any) {
        if (!this.formActive) {
            this.showTravellerForm.emit(_key);
            this.formActive = true;
        } else {
            this.showTravellerForm.emit(null);
            this.formActive = false;
        }
    }

    /**
     * showHideDetails
     * action on eye icon click
     */
    protected showHideDetails() {
        this.isShowingDetails = !this.isShowingDetails;
    }

    /**
     * title translation
     * @param {string} title
     * @returns {string}
     */
    protected translateTitle(_title: string): string {
        let output: string;
        switch (_title) {
            case "Mr":
                output = "M.";
                break;
            case "Mrs":
                output = "Mme";
                break;
            case "Ms":
                output = "Mlle";
                break;
        }

        return output;
    }

    /**
     * pax Type from whole word to accronyme
     * @param {string} type
     * @returns {string}
     */
    protected accronymType(_type: string): string {
        let output: string;
        switch (_type) {
            case "Adult":
                output = "ADT";
                break;
            case "Infant":
                output = "INF";
                break;
            case "Child":
                output = "CHD";
                break;
        }

        return output;
    }


    protected setMessage() {
        // this.message = '';

        let multiline = false;
        if (!_get(this.travellerItem, 'birthDate')) {
            this.message += Yii.t('wui-shared-js', 'Date de naissance manquante.');
            multiline = true;
        }

        if (!_get(this.travellerItem, 'citizenship')) {
            if (multiline) {
                this.message += "<br>";
            }
            this.message += Yii.t('wui-shared-js', 'Nationalité manquante.');
            multiline = true;
        }

        if (!_get(this.travellerItem, 'passport.number')) {
            if (multiline) {
                this.message += "<br>";
            }
            this.message += Yii.t('wui-shared-js', 'Numéro de passeport manquant.');
            multiline = true;
        }
        if (!_get(this.travellerItem, 'passport.validity.end')) {
            if (multiline) {
                this.message += "<br>";
            }
            this.message += Yii.t('wui-shared-js', 'Date de validité du passeport manquante.');
            multiline = true;
        }

        if (!_get(this.travellerItem, 'passport.issuance.country')) {
            if (multiline) {
                this.message += "<br>";
            }
            this.message += Yii.t('wui-shared-js', "Pays d'émission du passeport manquant.");
        }



    }

    protected getMissingApis(): number {
        //set nb of error to 0
        let output = 0;
        //Add 1 error if a field is missing
        if (!_get(this.travellerItem, 'citizenship')) {
            output++;
        }
        if (!_get(this.travellerItem, 'passport.number')) {
            output++;
        }
        if (!_get(this.travellerItem, 'passport.validity.end')) {
            output++;
        }
        if (!_get(this.travellerItem, 'passport.issuance.country')) {
            output++;
        }
        // return nb of missing fields
        return output;
    }


}
